<template>
  <div scroll-menu :class="{ locked }">
    <Slider slides-per-view="auto" :breakpoints="{768:{allowTouchMove: false}}" watch-overflow @initialized="init" class="hidden-tp-up">
      <slot />
    </Slider>
    <div class="hidden-ml-down">
      <slot/>
    </div>
  </div>
</template>

<style lang="less">
@import "~@/less/proj.less";

[scroll-menu] { z-index:9;
  .swiper-container { overflow: visible; width:auto; }
  .swiper-slide { .ib; width: auto; .medium; .pointer; }
  .swiper-slide + .swiper-slide { .ml(30); }
}
@media (min-width: @screen-tp-min) {
}

@media (min-width: @screen-dm-min) {
  [scroll-menu] {  }
}
</style>

<script>
import Slider from '@/views/components/Slider';

export default {
  name: 'ScrollMenu',
  components: { Slider },
  data() {
    return {
      breakPoint: { 1440: { allowTouchMove: false } },
      locked: false,
    };
  },
  methods: {
    init(swiper) {
      this.locked = swiper.isLocked;
    },
  },
};
</script>
